<template>
  <div>
    <div class="row mb-3">
      <div class="col-md-12">
        <router-link
          to="/principal/providers/add"
          class="btn btn-secondary"
          v-if="myRoleId === 1"
        >Agregar Proveedor</router-link>
      </div>
    </div>
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :totalRows="totalRecords"
      :sort-options="{
          enabled: true,
          initialSortBy: [{field: 'name', type: 'asc'}]
        }"
      :isLoading.sync="isLoading"
      styleClass="vgt-table bordered"
      :pagination-options="{
          enabled: true,
          mode: 'registros',
          position: 'top',
          perPage: 10,
          nextLabel: 'siguiente',
          prevLabel: 'anterior',
          rowsPerPageLabel: 'Filas por página',
          ofLabel: 'de',
          pageLabel: 'páginas', // for 'pages' mode
          allLabel: 'Todos',
        }"
      @on-page-change="onPageChange"
      @on-sort-change="onSortChange"
      @on-column-filter="onColumnFilter"
      @on-per-page-change="onPerPageChange"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'discount'">
          {{props.row.discount}} %
        </span>
        <span v-else-if="props.column.field == 'discount_client'">
          {{props.row.discount_client}} %
        </span>
         <span v-else-if="props.column.field == 'config'">
          <router-link
            v-if="myRoleId === 1"
            :to="{ name: 'providersParams', params: { id_provider: props.row.id_provider, name: props.row.name }}"
            class="btn btn-secondary"
          >Configurar</router-link>
            <button class="btn btn-danger m-2" @click="deleteO(props.row)" v-if="myRoleId === 1">
              <font-awesome-icon :icon="['fa', 'trash']" size="1x"/>
            </button>
        </span>
        <span v-else>
          {{props.formattedRow[props.column.field]}}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import { VueGoodTable } from 'vue-good-table'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    VueGoodTable
  },
  data () {
    return {
      rows: [],
      isLoading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: '',
          type: ''
        },
        page: 1,
        perPage: 10
      },
      columns: [
        {
          label: 'ID',
          field: 'id_provider',
          filterOptions: {
            placeholder: 'Nombre de Empresa',
            enabled: true
          }
        },
        {
          label: 'Nombre',
          field: 'name',
          filterOptions: {
            placeholder: 'Rfc',
            enabled: true
          }
        },
        {
          label: 'Siglas',
          field: 'siglas',
          filterOptions: {
            placeholder: 'Siglas',
            enabled: true
          }
        },
        // {
        //   label: 'Balance',
        //   field: 'balance',
        //   filterOptions: {
        //     placeholder: 'Dirección',
        //     enabled: true
        //   }
        // },
        {
          label: 'Descuento',
          field: 'discount',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true
          }
        },
        {
          label: 'Descuento Cliente',
          field: 'discount_client',
          filterOptions: {
            placeholder: 'Estado',
            enabled: true
          }
        },
        {
          label: 'Configurar Parametros',
          field: 'config'
        }
      ]
    }
  },
  computed: {
    myRoleId () {
      return this.$store.getters.currentRoleId
    }
  },
  methods: {
    updateParams (newProps) {
      this.serverParams = Object.assign({ page: 0 }, this.serverParams, newProps)
    },
    onPageChange (params) {
      this.updateParams({ page: params.currentPage })
      this.loadItems()
    },
    onPerPageChange (params) {
      this.updateParams({ perPage: params.currentPerPage })
      this.loadItems()
    },
    onSortChange (params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field
        }
      })
      this.loadItems()
    },
    onColumnFilter (params) {
      this.updateParams(params)
      this.loadItems()
    },
    async loadItems (first = false) {
      try {
        const response = await axiosAdelaService.post('/getProviders')
        console.log('', response)
        if (response.status === 200) {
          this.totalRecords = response.data.totalRecords
          if (this.totalRecords > 0) {
            this.rows = response.data.rows
          } else {
            this.rows = []
          }
        }
      } catch (error) {
        console.log(error)
        this.showError('No se pudieron obtener las empresas intentalo mas tarde.')
      }
    },
    async deleteO (row) {
      try {
        this.$dialog.confirm(`
          <div class="row justify-content-center">
            <div class="col-lg-11 text-center">
              <h4 style="color:red"><b>Por favor, confirma que deseas eliminar a este proveedor. <br>Esta acción no se podra deshacer...</b></h4>
            </div>
          </div>
        `)
          .then(async () => {
            const request = {
              ...row
            }
            // console.log('ESTO', request)
            const orders = await axiosAdelaService.post('/deleteProvider', request)
            // console.log('getEnterprisesSelected', orders)
            if (orders.status === 200) {
              this.$toastedPush({
                message: 'Proveedor eliminado..',
                type: 'success'
              })
              this.loadItems()
            }
          })
          .catch((err) => {
            console.log('presiono cancelar confirmationDialog', err)
          })
      } catch (error) {
        this.showError('No se pudo actualizar el almacen, intentelo mas tarde...')
      }
    }
  },
  mounted () {
    this.loadItems(true)
  }
}
</script>

<style>

</style>
